import * as commonTypes from './commonActionTypes';

const initialState = {
  cancelReasons: []
};

export default (state = initialState, action) => {
  switch (action.type) {
    case commonTypes.CLEAR_COMMON_DATA: {
      return Object.assign({}, initialState);
    }
    case commonTypes.SET_CANCEL_REASONS: {
      return { ...state, cancelReasons: action.payload };
    }
    default:
      return state;
  }
};
